import React from 'react';

// Quiet, non-invasive footnote explaining the asterisks on time/cost figures.
// Times and costs across My Trips are shown as rounded-up estimates.

const ApproxNote: React.FC<{ align?: 'left' | 'center' }> = ({ align = 'center' }) => (
  <div style={{ fontSize: 11, color: '#9aa6a0', textAlign: align, marginTop: 12 }}>
    * Times and costs are rounded-up estimates.
  </div>
);

export default ApproxNote;
